import $ from "jquery";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

window.addEventListener("maps-loaded", function (e) {
	initMaps();
});

function initMaps() {
	if ($(".et-block-map").length) {
		$(".et-block-map").each(function () {
			var map = new Et_Block_Map($(this));
		});
	}
}

function Et_Block_Map(_obj) {
	this.obj = _obj;
	this.map = null;
	this.mc = null;
	this.locations = window.map_markers;
	this.markers = [];
	this.init();
}

Et_Block_Map.prototype.init = function () {
	var me = this;
	var styles = map_styles;
	var options = {
		mapTypeControlOptions: {
			mapTypeIds: ["Styled"],
		},
		center: new google.maps.LatLng(28, -33.23411693572996),
		mapTypeControl: false,
		zoom: 12,
		minZoom: 4,
		mapTypeId: "Styled",
		zoomControl: true,
		scrollwheel: false,
		zoomControlOptions: {
			position: google.maps.ControlPosition.LEFT_CENTER,
		},
		scaleControl: true,
		streetViewControl: false,
		mapId: "ET_MAP_ID",
	};
	var div = $(this.obj).find(".et-block-map__map")[0];
	this.map = new google.maps.Map(div, options);

	var styledMapType = new google.maps.StyledMapType(styles, { name: "Styled" });
	me.map.mapTypes.set("Styled", styledMapType);

	google.maps.event.addDomListener(window, "resize", function () {
		var center = me.map.getCenter();
		google.maps.event.trigger(me.map, "resize");
		me.map.setCenter(center);
	});

	me.mostrarMarkers();
};

Et_Block_Map.prototype.mostrarMarkers = function () {
	var me = this;
	var LatLngList = [];
	for (var i = 0; i < me.locations.length; i++) {
		me.montarAdvancedMarker(me.locations[i]);
		LatLngList.push(new google.maps.LatLng(me.locations[i].lat, me.locations[i].lng));
	}

	//Centra el mapa para mostrar todos los markers
	var bounds = new google.maps.LatLngBounds();
	for (var i = 0, LtLgLen = LatLngList.length; i < LtLgLen; i++) {
		bounds.extend(LatLngList[i]);
	}

	if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
		var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 2, bounds.getNorthEast().lng() + 2);
		var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 2, bounds.getNorthEast().lng() - 2);
		bounds.extend(extendPoint1);
		bounds.extend(extendPoint2);
	}

	me.map.fitBounds(bounds);

	var clusterStyles = [
		{
			url: template_uri + "/img/map-pointer-plus.png",
			height: 45,
			width: 30,
			textColor: "transparent",
		},
	];

	var mcOptions = {
		gridSize: 40,
		styles: clusterStyles,
		maxZoom: 30,
		minZoom: 4,
	};

	me.mc = new MarkerClusterer(me.map, me.markers, mcOptions);
};

Et_Block_Map.prototype.montarAdvancedMarker = function (obj) {
	var me = this;

	const marker_tag = document.createElement("div");

	marker_tag.className = "et-map-marker";

	const marker_text = marker_tag.appendChild(document.createElement("div"));
	marker_text.className = "et-map-marker__text";
	marker_text.textContent = obj.title;

	var map = me.map;

	const markerView = new google.maps.marker.AdvancedMarkerElement({
		map,
		position: { lat: obj.lat, lng: obj.lng },
		content: marker_tag,
	});
};

Et_Block_Map.prototype.montarMarker = function (obj) {
	console.log(obj);
	var me = this;
	var icon = template_uri + "/img/map-pointer.png";
	var content;
	var marker = new google.maps.Marker({
		position: new google.maps.LatLng(obj.lat, obj.lng),
		map: me.map,
		title: obj.title,
		icon: icon,
		id: obj.id,
	});
	me.markers.push(marker);
	var content = obj.html;
	marker.infowindow = new google.maps.InfoWindow({
		content: content,
	});
	google.maps.event.addListener(marker, "click", function () {
		me.map.setZoom(18);
		var lat = marker.getPosition().lat();
		var pos = new google.maps.LatLng(lat, marker.getPosition().lng());
		me.map.setCenter(pos);
		pos_act = pos;
		if (infowindow) {
			infowindow.close();
		}
		infowindow = marker.infowindow;
		marker.infowindow.open(me.map, marker);
	});
};
